export default "__VITE_ASSET__d26be65d__"